import { Module } from 'wrapper6'
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'
import ObjectFitClass from '../utils/_object-fit'

const $ = jQuery

export default class NewsSlider extends Module {
  ready (app) {
    this.swipers = document.querySelectorAll('.mtt-cases-slider')
    this.loader = document.querySelector('#loader')

    this.addSwiper()
  }

  addSwiper () {
    if (this.swipers.length) {
      for (let i = 0; i < this.swipers.length; i++) {
        const swiperWrapper = this.swipers[i]

        this.terms = swiperWrapper.querySelectorAll('.mtt-cases-slider__term')

        this.swiper = swiperWrapper.querySelector('.mtt-cases-slider__slider')

        const nextArrow = swiperWrapper.querySelector('.mtt-swiper-button-next')
        const prevArrow = swiperWrapper.querySelector('.mtt-swiper-button-prev')

        const swiperClass = new Swiper(this.swiper, {
          slidesPerView: 1,
          spaceBetween: 24,
          watchOverflow: true,
          lazy: {
            loadPrevNext: true,
            checkInView: false
          },
          watchSlidesVisibility: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow
          },
          breakpoints: {
            700: {
              slidesPerView: 2
            },
            1100: {
              slidesPerView: 3
            }
          }
        })

        this.addFilter(swiperWrapper, swiperClass)
      }
    }
  }

  addFilter (swiperWrapper, swiperClass) {
    if (this.terms.length) {
      for (let i = 0; i < this.terms.length; i++) {
        const term = this.terms[i]

        term.addEventListener('click', () => {
          this.termID = term.getAttribute('data-id')
          swiperWrapper.querySelector('.mtt-cases-slider__term.active').classList.remove('active')
          term.classList.add('active')

          this.getCases(swiperWrapper, swiperClass)
        })
      }
    }
  }

  getCases (swiperWrapper, swiperClass) {
    this.loader.classList.add('show')

    const data = {
      action: 'filter_cases_slider',
      term: this.termID
    }

    jQuery.post(main_theme_objects.ajax_url, data, (response) => {
      if (response !== 0) {
        swiperWrapper.querySelector('.swiper-wrapper').innerHTML = response.markup
        swiperClass.update()
        swiperClass.lazy.load()
        new ObjectFitClass()
      }

      this.loader.classList.remove('show')
    })
  }
}
